





import { Component, Vue, Watch } from 'vue-property-decorator';

import SelectTag from '@/shared/components/select.tag.component.vue';
import ExpansionPanel from '@/shared/components/expansion.panel.component.vue';

@Component({
  components: {
    SelectTag,
    ExpansionPanel,
  },
})
export default class PartialSelectTag extends Vue {
  private switchState: boolean = true;
  private tags1 = [
    { name: 'Sandra Adams', group: 'Group 1', active: false, id: 1 },
    { name: 'Ali Connors', group: 'Group 1', active: true, id: 2 },
    { name: 'Trevor Hansen', group: 'Group 1', active: true, id: 3 },
    { name: 'Tucker Smith', group: 'Group 1', active: false, id: 4 },
    { name: 'Britta Holt', group: 'Group 2', active: false, id: 5 },
    { name: 'Jane Smith ', group: 'Group 2', active: false, id: 6 },
    { name: 'John Smith', group: 'Group 2', active: false, id: 7 },
    { name: 'Sandra Williams', group: 'Group 2', active: false, id: 8 },
  ];
  private tags2 = [
    { name: 'Sandra Adams', group: 'Group 1', active: false, id: 1 },
    { name: 'Ali Connors', group: 'Group 1', active: true, id: 2 },
    { name: 'Trevor Hansen', group: 'Group 1', active: true, id: 3 },
    { name: 'Tucker Smith', group: 'Group 1', active: false, id: 4 },
    { name: 'Britta Holt', group: 'Group 2', active: false, id: 5 },
    { name: 'Jane Smith ', group: 'Group 2', active: false, id: 6 },
    { name: 'John Smith', group: 'Group 2', active: false, id: 7 },
    { name: 'Sandra Williams', group: 'Group 2', active: false, id: 8 },
  ];
  private tags3 = [
    { name: 'Sandra Adams', group: 'Group 1', active: false, id: 1 },
    { name: 'Ali Connors', group: 'Group 1', active: true, id: 2 },
    { name: 'Trevor Hansen', group: 'Group 1', active: true, id: 3 },
    { name: 'Tucker Smith', group: 'Group 1', active: false, id: 4 },
    { name: 'Britta Holt', group: 'Group 2', active: false, id: 5 },
    { name: 'Jane Smith ', group: 'Group 2', active: false, id: 6 },
    { name: 'John Smith', group: 'Group 2', active: false, id: 7 },
    { name: 'Sandra Williams', group: 'Group 2', active: false, id: 8 },
  ];
  private selected: Array<any> = [];
}
